import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export default function InfoTooltip({
  text,
  width = 280,
  offsetY = 8,
  centerShift = 0.35, // 0 = allineato a sinistra, 0.5 = centrato perfetto. 
}) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const tipRef = useRef(null);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  const computePos = () => {
    const btn = btnRef.current;
    if (!btn) return;

    const r = btn.getBoundingClientRect();

    const top = r.bottom + offsetY + window.scrollY;

    let left = r.left + window.scrollX - width * centerShift;

    const pad = 12;
    const minLeft = window.scrollX + pad;
    const maxLeft = window.scrollX + window.innerWidth - pad - width;
    left = Math.max(minLeft, Math.min(left, maxLeft));

    setPos({ top, left });
  };

  useEffect(() => {
    const onDown = (e) => {
      const btn = btnRef.current;
      const tip = tipRef.current;

      if (btn && btn.contains(e.target)) return;
      if (tip && tip.contains(e.target)) return;

      setOpen(false);
    };

    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, []);

  useEffect(() => {
    if (!open) return;

    computePos();

    const onAnyScroll = () => computePos();
    const onResize = () => computePos();

    window.addEventListener("scroll", onAnyScroll, true);
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("scroll", onAnyScroll, true);
      window.removeEventListener("resize", onResize);
    };
  }, [open, width, offsetY, centerShift]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      <button
        ref={btnRef}
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="Informazioni"
        aria-expanded={open}
        title="Info"
        style={{
          width: 18,
          height: 18,
          borderRadius: "50%",
          border: "1px solid currentColor",
          color: "var(--brand-blue, #3390B3)",
          background: "transparent",
          fontSize: 12,
          fontWeight: 800,
          cursor: "pointer",
          lineHeight: "18px",
          padding: 0,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        i
      </button>

      {open &&
        createPortal(
          <div
            ref={tipRef}
            role="tooltip"
            style={{
              position: "absolute",
              top: pos.top,
              left: pos.left,
              zIndex: 9999,

              width,
              maxWidth: `min(${Math.max(width, 320)}px, calc(100vw - 24px))`,
              padding: "10px 12px",
              background: "#fff",
              borderRadius: 12,
              border: "1px solid rgba(51, 144, 179, 0.35)",
              boxShadow: "0 10px 28px rgba(0,0,0,0.16)",
              fontSize: 13,
              color: "#3390B3",

              whiteSpace: "normal",
              overflowWrap: "anywhere",
            }}
          >
            {text}
          </div>,
          document.body
        )}
    </>
  );
}
